import { z } from 'zod';

/**
 * The app's single US phone rule for a number an account is **given** (ADR-0035, bug 120891):
 * 10 digits, area code and exchange each starting 2–9 (NANP). It mirrors the backend's
 * `US_PHONE_NANP_REGEX` and is never stricter.
 *
 * Structure, not origin: ten digits cannot say which country a number belongs to (`9876543210` is
 * NANP-valid), so this rejects numbers that cannot exist, and OTP proves ownership.
 *
 * **Not for lookups.** Login and forgot password find an existing account and accept any 10 digits
 * (`phoneSchema` in `features/auth`), so an account created before this rule is never locked out.
 */
const US_PHONE_NANP = /^[2-9]\d{2}[2-9]\d{6}$/;

export function isUsPhone(phone: string): boolean {
  return US_PHONE_NANP.test(phone);
}

/**
 * `storedPhone` is the record's current number on an edit form: left unchanged it passes even if it
 * predates the rule, so a legacy record stays saveable. A changed number always meets the rule.
 */
export function usPhoneSchema(message: string, storedPhone?: string) {
  return z
    .string()
    .refine((phone) => (!!storedPhone && phone === storedPhone) || isUsPhone(phone), message);
}
